import { Locale, type LocalizedString } from "../Locale.js";
import { WeddingCakeDecorationStyle } from "../WeddingCakeDecorationStyle.js";

export const weddingCakeDecorationStyleNameMap = {
	[WeddingCakeDecorationStyle.Naked]: { [Locale.cs]: "Nahý" },
	[WeddingCakeDecorationStyle.HalfNaked]: { [Locale.cs]: "Polonahý" },
	[WeddingCakeDecorationStyle.Creamed]: { [Locale.cs]: "Krémovaný" },
	[WeddingCakeDecorationStyle.Birch]: { [Locale.cs]: "Bříza" },
	[WeddingCakeDecorationStyle.Individual]: { [Locale.cs]: "Individuální" },
} satisfies Record<WeddingCakeDecorationStyle, LocalizedString>;
